import { createUtcDateFromMoscowInput, formatMoscowDateInput } from "../../shared/lib/helpers/moscowDateTime";

export const getStatisticsWeek = (now = new Date()) => {
    // Для вычислений используем московскую календарную дату как дату UTC,
    // чтобы часовой пояс браузера и переход на летнее время не сдвигали границы недели.
    const day = new Date(`${formatMoscowDateInput(now)}T00:00:00Z`)
    day.setUTCDate(day.getUTCDate() - (day.getUTCDay() + 6) % 7)
    const from = day.toISOString().slice(0, 10)
    day.setUTCDate(day.getUTCDate() + 6)
    return {from, to: day.toISOString().slice(0, 10)}
}

export const getStatisticsRange = (fromDate: string, toDate: string) => {
    const from = createUtcDateFromMoscowInput(fromDate, '00:00')
    const lastDay = createUtcDateFromMoscowInput(toDate, '00:00')
    if(!from || !lastDay || from > lastDay) return null
    // В интерфейсе последний день включён, а API принимает диапазон [from, to).
    const to = new Date(lastDay.getTime() + 24 * 60 * 60 * 1000)
    return {from: from.toISOString(), to: to.toISOString()}
}
